import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Call, Page, SearchRequest } from '../model';
import { Crud } from './crud-abstract';

@Injectable({
  providedIn: 'root'
})
export class CallService extends Crud<Call>{
  override baseUrl = 'api/calls';

  search(request: SearchRequest): Observable<Page<Call>> {
    return this.http.get<Page<Call>>(`${this.baseUrl}/search`, { params: { ...request } });
  }
}
